import { Row, Col, Input, Label, Form, Button, FormFeedback, Spinner } from 'reactstrap'
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import React, { useState, Fragment, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { isObjEmpty, isUserLoggedIn } from '@utils'
import { useDispatch } from "react-redux"
import { UnlistedUser } from "../../views/redux/store"
import credit from "../../assets/images/passport.png"
import warning from "../../assets/images/warning.svg"

const VerificationDetails = () => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [comment, setComment] = useState("")
    const [spinnerStatus, setSpinnerStatus] = useState(true)
    const [companyName, setCompanyName] = useState('')
    const [companyCountry, setCompanyCountry] = useState('')
    const [vesselIMONumber, setVesselIMONumber] = useState('')
    const [clientEmail, setEmail] = useState("")
    const [errorEmail, setErrorEmail] = useState('')
    const [companyId, setCompanyId] = useState("")
    const dispatch = useDispatch()
    const loggedinUserDetails = JSON.parse(isUserLoggedIn())

    const ValidSchema = yup.object().shape({
        firstName: yup.string().trim().nullable().required('First Name is a required field'),
        lastName: yup.string().trim().nullable().required('Last Name is a required field'),
        companyName: yup.string().trim().nullable().required('Company Name is a required field'),
        companyCountry: yup.string().trim().nullable().required("Company Country is a required field"),
        vesselIMONumber: yup
            .string()
            .trim()
            .nullable()
            .matches(/^[\d,]+$/, 'IMO Number must be a number')
            .min(7, "Vessel IMO Number Must be Min 7 or max 8 numbers")
            .max(8, "Vessel IMO Number Must be Min 7 or max 8 numbers")
            .required("Vessel IMO Number is a required field")
    })

    useEffect(() => {
        if (clientEmail) {
            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(clientEmail)) {
                setErrorEmail('')
            } else {
                setErrorEmail('Email is invalid')
            }
        }
    }, [clientEmail])

    const { trigger, handleSubmit, control, setValue, formState: { errors } } =
        useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

    function FillingData() {
        setFirstName(loggedinUserDetails.firstName)
        setLastName(loggedinUserDetails.lastName)
        setValue("firstName", loggedinUserDetails.firstName)
        setValue("lastName", loggedinUserDetails.lastName)
        setEmail(loggedinUserDetails.email)
        setValue("clientEmail", loggedinUserDetails.email)
    }

    useEffect(() => {
        if (loggedinUserDetails) {
            // console.log(loggedinUserDetails, "Company ID")
            FillingData()
        }
    }, [])

    const CustomAlertTriangle = () => {
        return (
            <div className='d-flex'>
                <div style={{ width: "25px", height: "20px", color: "#000" }}>
                    <img src={warning} style={{ width: "25px" }}></img>
                </div>
                <div style={{ marginTop: "3px" }}>
                    <b>Verification Required!</b>&nbsp; You currently do not have a company related to your account.
                </div >
            </div>
        )
    }

    const onSubmit = () => {
        const data = { firstName, lastName, companyName, comment, companyCountry, vesselIMONumber }
        if (companyId.length) {
            data.companyId = companyId
        }
        trigger()
        if (isObjEmpty(errors)) {
            async function apiCall(wdata) {
                setSpinnerStatus(false)
                const responseData = await dispatch(UnlistedUser(wdata))
                {
                    if (responseData?.payload?.data) {
                        setCompanyName("")
                        setValue("companyName", "")
                        setCompanyCountry("")
                        setValue("companyCountry", "")
                        setVesselIMONumber("")
                        setValue("vesselIMONumber", "")
                        setCompanyId("")
                        setValue("companyId", "")
                        setComment("")
                    }
                }
                setSpinnerStatus(true)
            }
            data["clientEmail"] = clientEmail
            const wdata = { data, type: "Email Sent" }
            apiCall(wdata)
        }
    }

    return (
        <>
            <Row style={{ marginLeft: '0', marginRight: '0', padding: '0' }}>
                <Col sm='12' md='12' lg='12' xl='8' style={{ paddingLeft: "0px" }} >
                    <div className='cardpanwlviewwarpperleft1 inv-padding payment_padding' style={{ lineHeight: "29px" }} >
                        <div className='content-header' style={{ marginBottom: '0px' }}>
                            <Row className='m-0 header-style_payment mt-3 mx-2'>
                                <h1 className='headingStyle'>
                                    {`Welcome ${loggedinUserDetails.firstName} ${loggedinUserDetails.lastName} !`}
                                </h1>
                                <p className='mt-2 word_styling d-flex' style={{ lineHeight: "29px" }}>
                                    <CustomAlertTriangle ></CustomAlertTriangle>
                                </p>
                                <img src={credit} className='credit_img' style={{ width: "255px" }}></img>
                                <div className="">
                                    <div className="row">
                                        <div className="word_styling " >
                                            <h6 className='headingStyle mt-3'>Welcome to LISCR's RLM 300 Portal!</h6>
                                            <p style={{ lineHeight: "29px" }}>We're excited to have you on board. To ensure a smooth experience, we kindly request that you send us the following information by filling out the Verification details form on the right or through email at <a href="mailto:rlm300support@liscr.com">RLM300Support@liscr.com</a>:</p>
                                            <ol className='mt-2 mx-2'>
                                                <li><b>Your Full Name</b></li>
                                                {/* <li><b>Agent ID</b></li> */}
                                                <li><b>Account or Agent ID:</b> Please provide your account or agent ID, which can be found on your statement of accounts/invoices.</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-2 word_styling'>
                                    Once we verify your company, you'll have full access to your invoices and payment options. Feel free to reach out to our support team at <a href="mailto:rlm300support@liscr.com">RLM300Support@liscr.com</a> if you have any questions or need assistance.
                                </div>
                                <div className='mt-2 word_styling'>
                                    Thank you for choosing LISCR. Let's get started!
                                </div>
                            </Row>
                        </div>
                    </div>
                </Col>
                <Col sm='12' md='12' lg='12' xl='4' className='invoice_minH absolute_zero_padding ' style={{ paddingLeft: "0px" }}>
                    <div className='cardpanwlviewwarpperleftVerfication inv-padding payment_padding marginTopAligment'  >
                        <div className='content-header' style={{ marginBottom: '0px' }}>
                            <Row className='m-0 header-style_payment'>
                                <h6 className="mt-1 mx-1 headingStyle_cyan">
                                    Verification Details
                                </h6>
                                <Form onSubmit={handleSubmit(onSubmit)} style={{ paddingTop: '1px' }}>
                                    <div className='mt-1'>
                                        <Col sm='12' md='10' lg='10' xl='10' className='mx-1'>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='firstName'
                                                    name='firstName'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            invalid={errors.firstName && true}
                                                            value={firstName}
                                                            onChange={(val) => { onChange(val, setFirstName(val.target.value), setValue("firstName", val.target.value)) }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    First Name <span className='text-danger'>*</span>
                                                </Label>
                                                {errors.firstName && <FormFeedback>{errors.firstName.message}</FormFeedback>}
                                            </div>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='lastName'
                                                    name='lastName'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            invalid={errors.lastName && true}
                                                            value={lastName}
                                                            onChange={(val) => { onChange(val, setLastName(val.target.value), setValue("lastName", val.target.value)) }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    Last Name <span className='text-danger'>*</span>
                                                </Label>
                                                {errors.lastName && <FormFeedback>{errors.lastName.message}</FormFeedback>}
                                            </div>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='email'
                                                    name='email'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            invalid={errorEmail.length > 0 && true}
                                                            value={clientEmail}
                                                            onChange={(val) => { onChange(val, setEmail(val.target.value), setValue("clientEmail", val.target.value)) }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    Email<span className='text-danger'>*</span>
                                                </Label>
                                                {errorEmail.length ? <FormFeedback>{errorEmail}</FormFeedback> : ""}
                                            </div>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='companyName'
                                                    name='companyName'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            invalid={errors.companyName && true}
                                                            value={companyName}
                                                            onChange={(val) => { onChange(val, setCompanyName(val.target.value), setValue("companyName", val.target.value)) }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    Company Name <span className='text-danger'>*</span>
                                                </Label>
                                                {errors.companyName && <FormFeedback>{errors.companyName.message}</FormFeedback>}
                                            </div>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='companyCountry'
                                                    name='companyCountry'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            invalid={errors.companyCountry && true}
                                                            value={companyCountry}
                                                            onChange={(val) => { onChange(val, setCompanyCountry(val.target.value), setValue("companyCountry", val.target.value)) }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    Company Country <span className='text-danger'>*</span>
                                                </Label>
                                                {errors.companyCountry && <FormFeedback>{errors.companyCountry.message}</FormFeedback>}
                                            </div>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='vesselIMONumber'
                                                    name='vesselIMONumber'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            invalid={errors.vesselIMONumber && true}
                                                            value={vesselIMONumber}
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']
                                                                if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault()
                                                                }
                                                            }}
                                                            onChange={(val) => {
                                                                const input = val.target.value
                                                                if (/^\d{0,8}$/.test(input)) {
                                                                    onChange(val, setVesselIMONumber(input), setValue("vesselIMONumber", input))
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    Vessel IMO Number <span className='text-danger'>*</span>
                                                </Label>
                                                {errors.vesselIMONumber && <FormFeedback>{errors.vesselIMONumber.message}</FormFeedback>}
                                            </div>
                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='companyId'
                                                    name='companyId'
                                                    render={({ field: { onChange } }) => (
                                                        <Input
                                                            placeholder=''
                                                            value={companyId}
                                                            onChange={
                                                                (val) => {
                                                                    if (!isNaN(val.target.value)) {
                                                                        onChange(val, setCompanyId(val.target.value), setValue("companyId", val.target.value))
                                                                    }
                                                                }}
                                                        />
                                                    )}
                                                />
                                                <Label className='form-label' >
                                                    Account or Agent ID
                                                </Label>
                                            </div>

                                            <div className='payment-field-mt input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='comment'
                                                    name='comment'
                                                    render={({ field: { onChange } }) => <Input
                                                        placeholder=''
                                                        type='textarea'
                                                        style={{ height: "100px" }}
                                                        rows='2'
                                                        invalid={errors.billPrefix && true}
                                                        value={comment}
                                                        onChange={(val) => {
                                                            onChange(val, setComment(val.target.value))
                                                        }}
                                                    />}
                                                />
                                                <Label className='form-label'>
                                                    Comments
                                                </Label>
                                            </div>
                                        </Col>
                                        <Row className='model_popup_submit_btn mt-2 mb-2'>
                                            <Col>
                                                <Button color='secondary' className='btn-prev mt-1 mx-1' onClick={() => {
                                                    setCompanyName("")
                                                    setCompanyCountry("")
                                                    setVesselIMONumber("")
                                                    FillingData()
                                                    setComment("")
                                                    setCompanyId("")
                                                    setValue("companyId", "")
                                                    setValue("companyName", "")
                                                    setValue("companyCountry", "")
                                                    setValue("vesselIMONumber", "")
                                                }}
                                                    disabled={(((companyName === "" && comment === "" && companyId === "" && companyCountry === "" && vesselIMONumber === "") && (firstName === loggedinUserDetails.firstName && lastName === loggedinUserDetails.lastName && clientEmail === loggedinUserDetails.email)))}
                                                    style={{ width: "121px" }}
                                                >
                                                    <span className='align-middle d-sm-inline-block'>Reset</span>
                                                </Button>
                                                {(spinnerStatus) ? (
                                                    <Fragment>
                                                        {
                                                            <Button className='btn-next mt-1 mx-1' color='success' type='submit' style={{ width: "124px" }} >
                                                                <span className='align-middle d-sm-inline-block '>Send</span>
                                                            </Button>
                                                        }
                                                    </Fragment>
                                                ) : (
                                                    <Button className='btn-next mt-1 mx-1' color='success' type='submit' style={{ width: "180px" }}>
                                                        <Spinner color='primary' size='sm' className={'mr-2'} />
                                                        <span className='ml-50'>Loading...</span>
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>

                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default VerificationDetails